import React, { useState, useEffect } from 'react';
import axios from 'api/axios';
import { Spinner } from 'react-bootstrap';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { GaugeChart } from 'echarts/charts';
import {
    GridComponent,
    LegendComponent,
    TitleComponent,
    TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from 'helpers/utils';

import DefaultCard from 'components/mycomponents/DefaultCard';

echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    GaugeChart,
    CanvasRenderer,
    LegendComponent
]);

const getOptions = data => ({
    series: [
      {
        type: 'gauge',
        startAngle: 90,
        endAngle: -270,
        radius: '90%',
        pointer: {
          show: false
        },
        progress: {
          show: true,
          overlap: false,
          roundCap: true,
          clip: false,
          itemStyle: {
            color: getColor('primary')
          }
        },
        axisLine: {
          lineStyle: {
            width: 8,
            color: [[1, getColor('gray-200')]]
          }
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false
        },
        data: [
          {
            value: 90,
            detail: {
              offsetCenter: ['7%', '4%']
            }
          }
        ],
        detail: {
          width: 50,
          height: 14,
          fontSize: 28,
          fontWeight: 500,
          fontFamily: 'poppins',
          color: getColor('gray-500')
        }
      }
    ]
  });

const StudentProgress = () => {
    // Declare State Variable
    const [data, setData] = useState(null);
    const [loadingData, setLoadingData] = useState(false);

    // Declare Constant Variable
    const DATA_URL = '/dashboard';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    
    useEffect(() => {
        const getVehicleActivity = async () =>{
            setLoadingData(true);
            try {
                const response = await axios.get(`${DATA_URL}/student-progress`, {
                  headers: {
                    'Authorization': `Bearer ${TOKEN_APP}`
                  }
                });
                const responseResult = response?.data;
                const responseData = responseResult?.data;

                setData(responseData);

                setLoadingData(false);
                
            } catch (err) {
                setLoadingData(false);
                if (err.response) {
                    const response = err.response.data;
                    console.log(response.message);
                } else {
                    console.log('Something error with server. Please call administrator or developer.');
                }
            }
        }

        getVehicleActivity()
    }, [TOKEN_APP]);
    
    return (
        <DefaultCard>
            <DefaultCard.Header title={'Progres Siswa'} />
            <DefaultCard.Body>
                {
                  loadingData ? (
                    <div className="align-center">
                      <Spinner animation="border  " className="me-2" />
                      <span className="fs-4">Loading ...</span>
                    </div>
                  ) : (
                    <ReactEChartsCore
                        echarts={echarts}
                        option={getOptions(data ? data.total_now : 0)}
                        style={{ height: '10.3rem', widht: '10.3rem' }}
                    />
                  )
                }
            </DefaultCard.Body>
        </DefaultCard>
    )
}

StudentProgress.propTypes = {}

export default StudentProgress;